<div class="col-12 h-full">
  <p-divider align="center">
    <span class="p-tag">{{'Comm' | translate}}</span>
  </p-divider>
  @if (skeleton === true) {  
    @if (error === true) {
      <div class="text-center font-bold text-lg" style="color: red;">{{'Load_Data_KO' | translate}}</div>    
    }@else {      
      <p-skeleton width="100%" height="100%"/>
    }
  }@else {    
    @if (addComm===true) {
      <div class="p-inputgroup col-12">
        <textarea class="size_comment" id="textarea" [(ngModel)]="comment" [rows]="2" [cols]="30" pInputTextarea autoResize="true"
        (blur)="onOutComment()" (keyup)="preventEmoji($event)"
        >
        </textarea>
        <button type="button" pButton pRipple icon="pi pi-send" styleClass="p-button-success" (click)="clickSaveComment()"></button>
      </div>
    }
    @if (addNotif===true) {
        @if (comboUser.length !==0 && displayUserList===true) {
          <div class="col-12">
            <p-divider align="center">
              <span class="p-tag">{{'Notif_To' | translate}}</span>
            </p-divider>
            <p-multiSelect
              class="w-15rem pad_not"
              styleClass="min-w-full"
              [options]="comboUser"
              [(ngModel)]="destUser"
              placeholder="{{'UsersD' | translate}}"
              optionLabel="displayValue"
              display="chip"
              appendTo="body"
              >
            </p-multiSelect>
          </div>
        }
    }
    <ul class="chat">
        @for (commentaire of commentaires; track commentaire; let idx = $index) {
          <li class="clearfix">
            <div class="chat-body">
              <div class="header">
                <strong class="primary-font">{{ commentaire.User }}</strong
                  ><span class="right">{{ commentaire.Date | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
              </div>
                <p class="content white-space"
                  [ngClass]="{ send: commentaire.Sender == true, receive: commentaire.Sender == false }"
                >{{ commentaire.Value  }}</p>
            </div>
          </li>
        }
    </ul>
  }
</div>
